import React, {Component} from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'

class SignatureContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            variables: this.props.variables || {},
            onChange: this.props.onChange || function(){},
            firstName: content.firstName || '',
            lastName: content.lastName || '',
        }
        this.handleFormChange = this.handleFormChange.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
        })
    }

    componentDidMount() {
        this.triggerChanged()
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            firstName: content.firstName || '',
            lastName: content.lastName || '',
            variables: nextProps.variables || {},
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="firstName">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.signature_section.signer_first_name_label"
                            defaultMessage="Signer's first name"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            name="firstName"
                            value={this.state.firstName}
                            onChange={this.handleFormChange}
                            id="firstName"
                            type="text"
                            className="form-control"
                            placeholder={this.state.variables.customer.firstName}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.signature_section.signer_first_name_description"
                                defaultMessage="This name will pre-fill the signature signer's first name form"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="lastName">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.signature_section.signer_last_name_label"
                            defaultMessage="Signer's last name"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            name="lastName"
                            value={this.state.lastName}
                            onChange={this.handleFormChange}
                            id="lastName"
                            type="text"
                            className="form-control"
                            placeholder={this.state.variables.customer.lastName}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.signature_section.signer_last_name_description"
                                defaultMessage="This name will pre-fill the signature signer's last name form"
                            />
                        </small>
                    </div>
                </div>

            </div>
        );
    }
}

export default injectIntl(SignatureContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/signature/input.component.jsx